<script>
import { mapActions } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import DepartmentBasicInfoForm from './components/DepartmentBasicInfoForm';

export default {
  name: 'DepartmentDetails',
  components: {
    DepartmentBasicInfoForm,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      department: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/department/show/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('departmentDetails', ['fetchDepartment', 'saveDepartment']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchDepartment(this.params.id)
        .then(({ data }) => {
          this.department = data;
          this.updateTabTitle({ path: this.path, title: this.department.name });
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      return this.saveDepartment(this.department)
        .then(() => {
          this.showSuccessMessage('Abteilungen erfolgreich gespeichert!');
        })
        .catch(() => {
          this.showErrorMessage('Abteilungen konnte nicht gespeichert werden. Bitte versuche es erneut!');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<template>
  <div class="department-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching department information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>
      </v-toolbar>

      <v-form>
        <v-container fluid grid-list-lg pt-2 pa-0>
          <DepartmentBasicInfoForm :department="department" @save="save" />
        </v-container>
      </v-form>
    </template>
  </div>
</template>

<style lang="scss">
.department-detail {
  &-title {
    margin-bottom: 10px;
  }

  &-actions {
    margin: 5px 0;

    .v-btn:first-child {
      border-radius: 5px 0 0 5px;
    }

    .v-btn:last-child {
      border-radius: 0 5px 5px 0;
    }

    .v-btn + .v-btn {
      border-left: 1px solid #fff !important;
    }

    .v-btn {
      margin: 0;
      width: 35px;
      height: 35px;
      border-radius: 0px;
    }
  }

  &-tab {
    padding-top: 10px;

    &-title {
      margin-bottom: 10px;
    }
  }

  &-common-list {
    margin-top: 5px;
    .v-btn {
      margin: 0px;
      width: 30px;
      height: 30px;
    }

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        .v-btn {
          opacity: 1;
        }
      }

      .v-btn {
        opacity: 0;
      }
    }
  }

  .v-tabs {
    &__items {
      padding-bottom: 30px;
    }
  }

  .submit-button {
    margin-top: 20px;
  }
}
</style>
